import { CommonsStore, I18n } from "lego-gui-lib";
import {
  commonsStore as commonsStoreSource,
  RemoteApi,
  RouterStore,
  routerStore as routerStoreSource
} from "lego-gui-lib/lib";
import { createContext } from "react";
import { i18next } from "./i18n/i18n";
import { Auth } from "./model/auth";

const url = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL
  : "/api";

export const api = new RemoteApi(url);

const routerStore = routerStoreSource;
const commonsStore = commonsStoreSource;
const authStore = new Auth(api, commonsStore);
export const routerStoreContext = createContext(routerStore);
export const authStoreContext = createContext(authStore);

export interface MainStore {
  api: RemoteApi;
  router: RouterStore;
  commons: CommonsStore;
  auth: Auth;
  i18n: I18n;
  [k: string]: any;
}

export const mainStore: MainStore = {
  api: api,
  router: routerStore,
  commons: commonsStore,
  auth: authStore,
  i18n: i18next
};

if (process.env.NODE_ENV === "development") {
  // @ts-ignore
  window.hnsStore = mainStore;
}
